import { GraphQLClient } from 'graphql-request';
import { ActionsEntity, ActionsStatusEnum } from 'src/generated/graphql-types';
import { dispatch } from 'src/redux/config/configureStore';
import { setOfferingsActions } from 'src/redux/slices/investor.slice';
import { graphQLRequest } from '../graphQL/graphQLRequestModule';
import { getUpdateOfferingsActions } from '../graphQL/queries/investorPortal/getOfferingsActions';
import { UpdateStatusOfferingsActions } from '../graphQL/queries/investorPortal/updateOfferingsActions';

/**
 * GraphQL request for the investor personal files
 * @param token Given auth token
 * @param client GraphQL client
 * @param ids entities Ids to fetch
 * @param includePersonalFiles Whether to include personal files in the request
 * @returns Files of the requested id
 */
export async function getAndUpdateOfferingActions(
  token: string,
  client: GraphQLClient,
): Promise<any> {
  //send GQL request for the overview data
  const res = await graphQLRequest(token, client, getUpdateOfferingsActions);

  //set the data in the redux store
  const actions: ActionsEntity[] = res?.requestAllPublicOfferingActions;
  if (actions) dispatch(setOfferingsActions(actions));

  return res;
}

/**
 * GraphQL request for the investor personal files
 * @param token Given auth token
 * @param client GraphQL client
 * @param ids Offering ids to update
 * @param status New status
 * @returns Updated offering actions
 */
export async function updateOfferingActionsStatus(
  token: string,
  client: GraphQLClient,
  ids: string[],
  status: ActionsStatusEnum,
): Promise<any> {
  let variables = {
    input: {
      ids,
      status,
    },
  };

  const res = await graphQLRequest(token, client, UpdateStatusOfferingsActions, variables);

  return res;
}
